import React, { Component, ErrorInfo, ReactNode } from "react";
import { Card, Button, Container, Row, Col } from "@themesberg/react-bootstrap";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Container className="mt-5">
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <Card className="text-center">
                <Card.Body className="p-5">
                  <h2 className="text-danger mb-3">Something went wrong</h2>
                  <p className="text-muted mb-4">
                    We're sorry, but something unexpected happened. Please try refreshing the page.
                  </p>
                  {this.state.error && (
                    <details className="text-start mb-4">
                      <summary className="text-danger cursor-pointer">Error Details</summary>
                      <pre className="bg-light p-3 mt-2 text-wrap">
                        {this.state.error.toString()}
                      </pre>
                    </details>
                  )}
                  <Button
                    variant="primary"
                    onClick={() => window.location.reload()}
                  >
                    Refresh Page
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;